module.exports = __webpack_public_path__ + "img/operators-hero-bg.07a1ee78.png";